import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Formik, Field, Form } from "formik";
import M from "materialize-css";

import { db } from "../lib/firebase";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import Layout from "../components/shared/Layout";
import Loading from "../components/shared/Loading";
import InputField from "../components/shared/InputField";
import StateSelector from "../components/shared/StateSelector";
import CardPanel from "../components/shared/CardPanel";
import CardHeader from "../components/shared/CardHeader";
import CardTitle from "../components/shared/CardSearchTable/Title";

import { useMaterialInputFields } from "../hooks/useMaterialInputFields";

const initialOrg = {
  name: "",
  streetAddress: "",
  secondaryAddress: "",
  city: "",
  state: "",
  phone: "",
  fax: "",
  zip: "",
};

export default function EditOrganization() {
  const [editOrg, setEditOrg] = useState(initialOrg);
  useMaterialInputFields(editOrg.loaded);

  const { id } = useParams();

  const orgs = collection(db, "organizations")
  const orgDoc = doc(orgs, id);

  useEffect(() => {
    (async () => {
      const org = await getDoc(orgDoc);
      setEditOrg({ ...initialOrg, ...org.data(), loaded: true });
    })();
  }, [id]);

  const handleSubmit = async (values) => {
    // slice keys to update
    const keys = Object.keys(initialOrg);
    const update = keys.reduce((acc, key) => {
      acc[key] = values[key];
      return acc;
    }, {});

    try {
      await updateDoc(orgDoc, update);
      M.toast({ html: "Organization updated successfully!" });
    } catch (err) {
      console.error(err);
      M.toast({ html: "There was an error updating the organization" });
    }
  };

  return (
    <Layout>
      <CardPanel>
        <CardTitle
          header={`Edit ${editOrg.name}`}
          tooltip={`Edit ${editOrg.name}'s details.`}
        />
        <br />
        {editOrg.loaded ? (
          <Formik initialValues={editOrg} onSubmit={handleSubmit}>
            <Form>
              <CardHeader text="General Information" icon="group" />
              <div className="row">
                <InputField name="name" label="Organization Name" size="s12" />
              </div>

              <CardHeader text="Address Information" icon="location_city" />
              <div className="row">
                <InputField name="streetAddress" label="Street Address" />
                <InputField name="secondaryAddress" label="Secondary Address" />
              </div>
              <div className="row">
                <InputField size="s4" name="city" label="City" />
                <StateSelector />
                <InputField size="s4" name="zip" label="Zip Code" />
              </div>

              <CardHeader text="Contact Information" icon="contacts" />
              <div className="row">
                <InputField name="phone" label="Phone" />
                <InputField name="fax" label="Fax" />
              </div>

              <div className="right-align">
                <button type="submit" className="btn green">
                  Update Organization
                </button>
              </div>
            </Form>
          </Formik>
        ) : (
          <Loading />
        )}
      </CardPanel>
    </Layout>
  );
}
